// Laboratory documentation: https://product.hubteam.com/docs/laboratory/guides/coding-a-frontend-experiment.html

import { createClient } from 'laboratory-lib';
import portalIdParser from 'PortalIdParser';
import experiments from '../../experiments.yaml';
export const laboratoryClient = createClient({
  quickFetchLabel: 'experiment-treatments',
  identifiers: {
    portalId: portalIdParser.get()
  },
  experiments: experiments
});
export const logExposure = treatmentKey => laboratoryClient.logExposure(treatmentKey);